import { t } from '../../shared/config/translations'
import { getCollectionStoreState } from '../stores/collectionStore'
import { formatRelativeTime } from '../utils/format'

/** Last-sync wording shared by the web header and the native pull title. */
export function collectionSyncStatusText(): string {
	const { phase, status } = getCollectionStoreState()
	const job = status?.job
	if (phase === 'syncing' && job)
		return `${t('collection.syncChecking')}… ${job.current}/${job.total || '?'}`
	if (!status?.syncedAt) return ''
	return t('collection.syncedAt').replace(
		'%{time}',
		formatRelativeTime(status.syncedAt),
	)
}
